import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'loop-agentic-insights.field-annotations';

/**
 * A dev-only overlay that labels each rendered value with the contract field it came from, so a
 * design conversation can name a field instead of describing where it sits on screen.
 *
 * Off by default and only offered where dev tools are, but persisted so a reload mid-discussion does
 * not silently drop the labels.
 */
const hasLocalStorage = (): boolean =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const read = (): boolean =>
  hasLocalStorage() ? window.localStorage.getItem(STORAGE_KEY) === 'on' : false;

let cached = read();
const listeners = new Set<() => void>();

const subscribe = (onStoreChange: () => void) => {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
};

export const setFieldAnnotations = (next: boolean) => {
  if (next === cached) return;
  cached = next;
  if (hasLocalStorage()) window.localStorage.setItem(STORAGE_KEY, next ? 'on' : 'off');
  for (const listener of listeners) listener();
};

export const useFieldAnnotations = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => cached,
    () => false,
  );
